import Component from 'Component';
import Location from "./place/Location";
import Panorama from "./place/Panorama";

export default class Place extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Location(this.App, this._namespace),
    new Panorama(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}